import React from "react";
import { sortBy } from "lodash";
import { useNavigate } from "react-router-dom";
import { Viewer } from "components/auth/types";

type List = {
  id: string;
  name: string;
}

type Props = {
  viewer: Viewer;
}

// removed legacy State interface in functional component version

const ListsIndexPage: React.FC<Props> = ({ viewer }) => {
  const navigate = useNavigate();
  const [hasListErr, setHasListErr] = React.useState(false);

  React.useEffect(() => {
    if (viewer.lists && viewer.lists.length) {
      const primaryLists = sortBy(
        viewer.lists.filter((list: List) => !list.name.match(/denial|move/i)),
        "name",
      );
      if (primaryLists.length) {
        navigate(`/dash/manager/lists/${primaryLists[0].id}`);
      } else {
        setHasListErr(true);
      }
    } else {
      setHasListErr(true);
    }
  }, [viewer, navigate]);

  if (hasListErr) {
    return (
      <h4 className="text-center">
        Can not find list for your user account. Please ask your supervisor to add a list to your
        account.
      </h4>
    );
  }
  return null;
};

export default ListsIndexPage;
